import { EventName } from '@lit/react/create-component';
import { BlocksPrimaryNavItem } from 'blocks-nextjs/blocks-web-components/components/primary-nav-item/primary-nav-item';
import { BlocksNavSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

/**
 * @deprecated - This component `CatPrimaryNavItem` has been deprecated and the updated version will be available with name `CatPrimaryNavItemLabs`. New component will be found under labs folder from Minor Release 3.10.0, `CatPrimaryNavItem` will be removed in 5.0 major release.
 */
export const CatPrimaryNavItem = createComponent({
  react: React,
  tagName: 'cat-primary-nav-item',
  elementClass: BlocksPrimaryNavItem,
  events: {
    onBlNavSelect: 'bl-nav-select' as EventName<BlocksNavSelectEvent>
  }
});
